export const CONFIRMATION_HEADLINE = '[confirmation_headline]';
export const CONFIRMATION_MESSAGING = '[confirmation_messaging]';
export const SESSIONS_PAGE = '[sessions_page]';
export const VIRTUAL_EVENT_PAGE = '[virtual_event_page]';
export const EVENT_DATE = '[event_date]';
export const START_TIME = '[start_time]';

export const DYNAMIC_TAGS = [
    CONFIRMATION_HEADLINE,
    CONFIRMATION_MESSAGING,
    SESSIONS_PAGE,
    VIRTUAL_EVENT_PAGE,
    EVENT_DATE,
    START_TIME,
];
